export const contentEditionDrawerWidth = 460;
export const contentEditionDrawerSmallWidth = 400;
